import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import { DataTable, IconButton, Loadable } from "components/support";

import Snackbar from "material-ui/Snackbar";

class DataTableView extends Component {
  config = {
    identifier: "id",
    columns: [
      {
        accessor: "uuid",
        show: false
      },
      {
        accessor: "company_uuid",
        show: false
      },
      {
        accessor: "name",
        Header: "Nome"
      },
      {
        accessor: "username",
        Header: "E-mail"
      },
      {
        id: "company",
        accessor: "company.slug",
        Header: "Empresa",
        align: "center",
        sortable: false
      },
      {
        id: "actions",
        Header: "Ações",
        align: "right",
        sortable: false,
        Cell: props => (
          <div>
            <IconButton
              mini
              icon="search"
              onClick={() =>
                this.props.presenter.onViewUser(props.row._original)
              }
            />
            <IconButton
              mini
              icon="mode_edit"
              onClick={() =>
                this.props.presenter.onEditUser(props.row._original)
              }
            />

            {props.row.uuid !==
              this.props.presenter.viewModel.currentUser.uuid && (
              <IconButton
                mini
                icon="delete"
                onClick={() =>
                  this.props.presenter.onRequestDelete(props.row._original)
                }
              />
            )}
          </div>
        )
      }
    ]
  };

  constructor(props) {
    super(props);
    this.presenter = props.presenter;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      this.presenter.onFilterChange(nextProps.filter);
    }
  }

  handleDataTableChange = ({ field, value }) => {
    this.presenter.onOrderChange(field, value);
  };

  handlePageChange = page => {
    this.presenter.onPageChange(page + 1);
  };

  render() {
    const {
      errorable,
      loading,
      resultSet,
      pagination,
      order
    } = this.props.viewModel;
    return (
      <div>
        <h3 style={{ textAlign: "right", padding: 10, margin: 0 }}>
          {pagination.total} usuário(s) encontrado(s).
        </h3>
        <Paper elevation={1} className="user__content">
          <Snackbar
            open={errorable.visible}
            message={errorable.content}
            autoHideDuration={4000}
            onRequestClose={() => {
              errorable.visible = false;
              errorable.content = "";
            }}
          />
          <Loadable loading={loading}>
            <DataTable
              manual
              resultSet={resultSet}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.currentPage}
              config={this.config}
              onChange={this.handleDataTableChange}
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={this.handlePageChange}
            />
          </Loadable>
        </Paper>
      </div>
    );
  }
}

export default DataTableView;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/data-table/data-table.view.js